import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { InfoCard } from '../../../../vtex-apps/store-components/InfoCard/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function SliderLayoutTemplate() {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'SliderLayout',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Slider Layout (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'slider-layout-1__flex-row', mzTitle: 'MZ | Banner' }, [
				SliderLayout({ mzTitle: 'Layout do slider', blockClass: 'home__slider-1' }, [
					FlexLayoutRow(
						{
							blockClass: 'home_slider--flex-row-1',
						},
						[
							InfoCard({
								imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								headline: 'Heading banner',
								subhead:
									'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim donec blandit dignissim porta. Sed in tellus in luctus. Ultricies nunc lectus urna eget purus lorem consequat donec. Sapien natoque nullam amet.',
								callToActionText: 'CTA Label Button',
								blockClass: 'home_slider--info-card-1',
							}),
						],
					),
					FlexLayoutRow(
						{
							blockClass: 'home_slider--flex-row-1',
						},
						[
							InfoCard({
								imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
								headline: 'Heading banner',
								subhead:
									'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Enim donec blandit dignissim porta. Sed in tellus in luctus. Ultricies nunc lectus urna eget purus lorem consequat donec. Sapien natoque nullam amet.',
								callToActionText: 'CTA Label Button',
								blockClass: 'home_slider--info-card-1',
							}),
						],
					),
				]),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--slider-1-arrow-color', name: 'Arrows' },
			{ from: '--brand-color-primary-pure', to: '--slider-1-arrow-background', name: 'Slider' },
			{ from: '--brand-color-primary-pure', to: '--slider-1-dots', name: 'Dots' },
			{ from: '--white', to: '--slider-1-card-cta-bg', name: 'CTA Background' },
			{ from: '--white', to: '--slider-1-card-cta-hover', name: 'CTA Background Hover' },
			{ from: '--white', to: '--slider-1-card-cta-focus', name: 'CTA Background Focus' },
			{ from: '--black', to: '--slider-1-card-cta-color', name: 'CTA Text Color' },
			{ from: '--brand-color-primary-pure', to: '--slider-1-text-color', name: 'Text Color' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--slider-1-border-radius', name: 'Slider Border Radius' },
			{ from: '--border-radius-none', to: '--slider-1-card-cta-borderradius', name: 'CTA Border Radius' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-display', to: '--slider-1-card-headline-fontsize', name: 'Headline Desktop' },
			{ from: '--font-size-md', to: '--slider-1-card-subhead-fontsize', name: 'Subhead Desktop' },
			{ from: '--font-size-sm', to: '--slider-1-card-cta-fs', name: 'CTA Desktop' },
			//mobile
			{ from: '--font-size-lg', to: '--slider-1-card-headline-fs-m', name: 'Headline Mobile' },
			{ from: '--font-size-sm', to: '--slider-1-card-subhead-fs-m', name: 'Subhead Mobile' },
			{ from: '--font-size-sm', to: '--slider-1-card-cta-fs-m', name: 'CTA Mobile' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-md', to: '--slider-1-arrow-size', name: 'Tamanho Arrow' },
			{ from: '--spacing-sm', to: '--slider-1-dot-width', name: 'Largura Dot' },
			{ from: '--spacing-xxs', to: '--slider-1-dot-height', name: 'Altura Dot' },
			{ from: '--spacing-xxs', to: '--slider-1-dots-container-spacing', name: 'Espaçamento Dot' },
			{ from: '--spacing-sm', to: '--slider-1-dots-bottom', name: 'Margem inferior Dots' },
			{ from: '--spacing-sm', to: '--slider-1-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-xxs', to: '--slider-1-dot-height-active', name: 'Dot Height Active' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--slider-1-card-cta-fontfamily', name: 'CTA Font Family' },
			{ from: '--main-font', to: '--slider-1-card-subhead-fontfamily', name: 'Subhead Font Family' },
			{ from: '--main-font', to: '--slider-1-card-headline-fontfamily', name: 'Headline Font Family' },
		],
	},
];
